"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/*@ngInject*/
exports.default = ['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('order', {
            url: '/order',
            template: require('../views/order-list.html'),
            controller: 'OrderListController',
            controllerAs: 'orders'
        });
    }];



//////////////////
// WEBPACK FOOTER
// ./scripts/apps/order-list/config/routes.js
// module id = 418
// module chunks = 0